import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=6f72f8c6&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=6f72f8c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72f8c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f72f8c6')) {
      api.createRecord('6f72f8c6', component.options)
    } else {
      api.reload('6f72f8c6', component.options)
    }
    module.hot.accept("./Student.vue?vue&type=template&id=6f72f8c6&scoped=true", function () {
      api.rerender('6f72f8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/Student.vue"
export default component.exports